<div class="container">
  <mat-card class="card2">
   
          <h4 class="card-title">Edit Voucher</h4>
      
      <form  (ngSubmit)="f.form.valid && EditVoucher()" #f="ngForm">
        <div class="row">
          <div class="col-md-4">
  
                  <mat-form-field class="example-full-width">
          
              <mat-label>Voucher Code</mat-label>
              <input matInput placeholder="Voucher Code" name="code" [(ngModel)]="addForm.code" #code="ngModel" [ngClass]="{ 'is-invalid': f.submitted && code.invalid }" required />
        
              <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                <div *ngIf="firstName.errors.required">Name is required</div>
            </div>        -->
            </mat-form-field>
           
            <div
            [hidden]="code.valid || code.pristine"
            class="erro1"
          >Voucher Code is Required
          </div></div>
            <div class="col-md-4">
  
            <mat-form-field class="example-full-width">
              <mat-label>Select Type</mat-label>
              <mat-select [(ngModel)]="addForm.voucher_type"  name="voucher_type" placeholder="Select Type" #ti="ngModel" required>
                  <mat-option value="fixed">Fixed</mat-option>
                  <mat-option value="percentage">Percentage</mat-option>
                </mat-select>
            </mat-form-field>
              <div
            [hidden]="ti.valid || ti.pristine"
            class="erro1"
          >Type is Required
          </div>
  </div>
  <ng-container *ngIf="addForm.voucher_type=='fixed'; else percentage">
    <div class="col-md-4">
  
      <mat-form-field class="example-full-width">

  <mat-label>Order Above</mat-label>
  <input matInput placeholder="Order Above" name="above" type="number" [(ngModel)]="addForm.orderAbove" #orderAbove="ngModel" [ngClass]="{ 'is-invalid': f.submitted && orderAbove.invalid }" required />

  <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
    <div *ngIf="firstName.errors.required">Name is required</div>
</div>        -->
</mat-form-field>

<div
[hidden]="orderAbove.valid || orderAbove.pristine"
class="erro1"
>Order Above is Required
</div></div>
          <div class="col-md-4">
  
                  <mat-form-field class="example-full-width">
          
              <mat-label>Max Fix Amount</mat-label>
              <input matInput placeholder="Amount" name="amount" type="number" [(ngModel)]="addForm.fixamount" #amount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && amount.invalid }" required />
        
              <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                <div *ngIf="firstName.errors.required">Name is required</div>
            </div>        -->
            </mat-form-field>
           
            <div
            [hidden]="amount.valid || amount.pristine"
            class="erro1"
          >Amount is Required
          </div>
          </div>  
            <div class="col-md-4">
      
                  <mat-form-field >
                      <mat-label>Start Date</mat-label>
                      <input readonly (click)="picker1.open()" matInput [matDatepicker]="picker1" name="start" [(ngModel)]="addForm.start" #start="ngModel" required>
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field></div>
             
                <div class="col-md-4">
      
                  <mat-form-field >
                      <mat-label>End Date</mat-label>
                      <input  readonly (click)="picker.open()" matInput [matDatepicker]="picker" name="end" [(ngModel)]="addForm.end" #end="ngModel" required>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field></div>
          
             
</ng-container>
<ng-template #percentage>
      <div class="col-md-4">

              <mat-form-field class="example-full-width">
      
          <mat-label>Voucher Percentage</mat-label>
          <input matInput placeholder="Voucher Percentage" name="Offer_percentage" [(ngModel)]="addForm.Offer_percentage"  #Offer_percentage="ngModel" [ngClass]="{ 'is-invalid': f.submitted && Offer_percentage.invalid }" required />
        
          <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
            <div *ngIf="firstName.errors.required">Name is required</div>
        </div>        -->
        </mat-form-field>
       
        <div
        [hidden]="Offer_percentage.valid || Offer_percentage.pristine"
        class="erro1"
      >Voucher Percentage  is Required
      </div>
      </div>  
      <div class="col-md-4">

          <mat-form-field class="example-full-width">
  
      <mat-label>Max Fix Amount</mat-label>
      <input matInput placeholder="Max Fix Amount" name="fixamount" [(ngModel)]="addForm.fixamount" #fixamount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fixamount.invalid }" required />
        
      <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
        <div *ngIf="firstName.errors.required">Name is required</div>
    </div>        -->
    </mat-form-field>
   
    <div
    [hidden]="fixamount.valid || fixamount.pristine"
    class="erro1"
  >Fixamount is Required
  </div>
  </div>  
  <div class="col-md-4">
  
    <mat-form-field class="example-full-width">

<mat-label>Order Above</mat-label>
<input matInput placeholder="Order Above" name="above" type="number" [(ngModel)]="addForm.orderAbove" #orderAbove="ngModel" [ngClass]="{ 'is-invalid': f.submitted && orderAbove.invalid }" required />

<!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
  <div *ngIf="firstName.errors.required">Name is required</div>
</div>        -->
</mat-form-field>

<div
[hidden]="orderAbove.valid || orderAbove.pristine"
class="erro1"
>Order Above is Required
</div></div>
        <div class="col-md-4">
  
              <mat-form-field >
                  <mat-label>Start Date</mat-label>
                  <input readonly (click)="picker1.open()" matInput [matDatepicker]="picker1" name="start" [(ngModel)]="addForm.start" #start="ngModel" required>
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field></div>
         
            <div class="col-md-4">
  
              <mat-form-field >
                  <mat-label>End Date</mat-label>
                  <input readonly (click)="picker.open()" matInput [matDatepicker]="picker" name="end" [(ngModel)]="addForm.end" #end="ngModel" required>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field></div>
           
         
</ng-template>
</div>
  <mat-slide-toggle
  [(ngModel)]="addForm.status"
  name="status"
  #status="ngModel"
  >status</mat-slide-toggle
><br><br>      <button mat-raised-button class="add" [disabled]="f.invalid">EDIT VOUCHER</button>
  
      </form>
      </mat-card></div>